import React, {useState, useEffect, useCallback, useMemo} from 'react'
import {inject, observer} from 'mobx-react'
import DialogModal from '../DialogModal'
import {InputField} from '../InputForms'
import {Icon, IconTypes} from '../Buttons'
import css from './style.css'
import {debounce} from 'lodash'

export function EditCategoriesButton({agent, children}) {
  const [isOpen, setOpen] = useState(false)
  function open() {
    setOpen(true)
  }
  function close() {
    setOpen(false)
  }
  return <React.Fragment>
    {children(open)}
    {isOpen && <AddCategoryModal agent={agent} onClose={close}/>}
    </React.Fragment>
}

const AddCategoryModal = inject('store', 'localizationStore')(observer(function AddCategoryModal({agent, onClose, store, localizationStore}) {
  useEffect(() => {
    store.categoriesStore.loadCategories()
  }, [])

  useEffect(() => {
    agent && agent.getAgentsCategoriesRequest()
  }, [agent])

  const {categoriesStore} = store

  const isAdmin = store.isAdministrator()
  return <DialogModal onClose={onClose}>
    <div>
      {isAdmin && <React.Fragment>
        {localizationStore.locale.new_category}
        <AddCategoryInput store={store}/>
      </React.Fragment>}
      {localizationStore.locale.all_categories}
      <div>
        <CategoriesList categoriesStore={categoriesStore} agent={agent} editable={isAdmin}/>
      </div>
    </div>
  </DialogModal>
}))

function AddCategoryInput({store}) {
  const [name, setName] = useState('')
  function onChange(e) {
    setName(e.target.value)
  }
  async function addCategory() {
    try {
      await store.categoriesStore.createCategory(name)
      setName('')
    } catch (e) {

    }
  }
  return <div className={css.addCategoryRow}>
    <InputField value={name} onChange={onChange} />
    <Icon type={IconTypes.add} onClick={addCategory}/>
  </div>
}

const CategoriesList = observer(function CategoriesList({categoriesStore, agent, editable}) {
  function deleteCategory(category) {
    return categoriesStore.deleteCategory(category)
  }

  const updateCategoryName = useCallback(function updateCategoryName(category, name) {
    if (category.name !== name) {
      categoriesStore.updateCategory(category, name)
    }
  }, [categoriesStore])

  const updateCategoryIndex = useCallback(function updateCategoryIndex(category, index) {
    const indexNumber = parseInt(index, 10)
    if (isNaN(indexNumber)) {
      throw Error('The index parameter should be a decimal integer')
    }
    if (category.index !== indexNumber) {
      categoriesStore.updateCategory(category, indexNumber)
    }
  }, [categoriesStore])

  const {categories} = categoriesStore
  return <ul className={css.categoriesList}>
    {categories.list.map(category => {
      return <li key={category.id}>
        {editable && <SyncedInputField
          object={category}
          property={'index'}
          onSync={updateCategoryIndex}
          delay={500}
          min={0}
          max={categories.list.length - 1}
          type={'number'}
          className={css.indexField}
        />}
        <SyncedInputField
          object={category}
          property={'name'}
          onSync={updateCategoryName}
          delay={1000}
          type={'text'}
          className={css.nameField}
          disabled={!editable}
        />
        <CategoryCheckbox agent={agent} category={category}/>
        {editable && <Icon type={IconTypes.delete} onClick={() => deleteCategory(category)}/>}
      </li>
    })}
  </ul>
})

function SyncedInputField({object, property, onSync, delay= 1000, ...rest}) {
  const [value, setValue] = useState(object[property])
  const update = useMemo(() => debounce(onSync, delay), [onSync])
  const onChange = useCallback(e => {
    setValue(e.target.value)
  }, [])
  useEffect(() => {
    update(object, value)
  }, [object, value])
  useEffect(() => {
    setValue(object[property])
  }, [object[property]])
  return <InputField
    value={value}
    {...rest}
    onChange={onChange}
  />
}

const CategoryCheckbox = observer(function CategoryCheckbox({agent, category}) {
  const {categories: agentCategories} = agent
  const checked = agentCategories.list.some(_cat => _cat.id === category.id)
  const onChange = useCallback(e => {
    if (!checked) {
      agent.addCategory(category)
    } else {
      agent.removeCategory(category)
    }
  }, [checked])
  return <input
    type='checkbox'
    checked={checked}
    onChange={onChange}/>
})

export default AddCategoryModal



// WEBPACK FOOTER //
// ./src/components/AddCategoryModal/index.js